import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useDispatch } from 'react-redux'
import { resetUserProfile } from '@/redux/userProfile/actions'
import {
  useUserPartnerSlug,
  useSignupProgress,
} from '@/redux/userConfig/selectors'
import { setActiveStepIndex } from '@/redux/signup/actions'
import { Loading } from '@/components'
import { authTokenStorageKey, idTokenStorageKey, URL_PREFIX } from '@/constants'

const Callback = () => {
  const dispatch = useDispatch()
  const {
    getAccessTokenSilently,
    isAuthenticated,
    isLoading,
    getIdTokenClaims,
  } = useAuth0()
  const partnerSlug = useUserPartnerSlug()
  const signupProgress = useSignupProgress()

  const getToken = async () => {
    const token = await getAccessTokenSilently()

    if (token) {
      sessionStorage.setItem(authTokenStorageKey, token)

      const idToken = await getIdTokenClaims()

      if (idToken) {
        // eslint-disable-next-line no-underscore-dangle
        sessionStorage.setItem(idTokenStorageKey, idToken?.__raw)
      }
    }
  }

  if (isLoading) {
    return <Loading />
  }

  if (isAuthenticated) {
    getToken()
    dispatch(setActiveStepIndex(signupProgress + 1))
  } else {
    dispatch(resetUserProfile())

    if (partnerSlug) {
      // The timeout is the way Redux Docs show how to perform an action after a dispatch action
      // https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-middleware-to-enable-async-logic
      setTimeout(() => {
        window.location.href = `${window.location.origin}/${URL_PREFIX}/${partnerSlug}/`
      })
    }
  }

  return null
}

export default Callback
